module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<input id=\"outsideColorPicker\" name=\"outsideColorPicker\" type=\"color\" value=\"")
    ; __append(escapeFn( mobileOutsideColor ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n<input id=\"outsideColor\" name=\"outsideColor\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( mobileOutsideColor ))
    ; __append("\" />")
  }
  return __output;

}